import React, { useState } from 'react';
import { ref, get } from 'firebase/database';
import { database } from './firebaseConfig';
import { storeChatId } from './chatId';
import './KeyScreen.css';

const KeyScreen = ({ onPaired }) => {
  const [value, setValue] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | error
  const [errorMsg, setErrorMsg] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    const key = value.trim().toUpperCase();
    if (!key || status === 'loading') return;

    setStatus('loading');
    setErrorMsg('');

    try {
      const snap = await get(ref(database, `accessKeys/${key}`));
      const chatId = snap.val();
      if (!chatId) {
        setStatus('error');
        setErrorMsg('Ключ не знайдено. Перевірте його правильність або отримайте новий у боті.');
        return;
      }
      storeChatId(chatId);
      onPaired(String(chatId));
    } catch (err) {
      setStatus('error');
      setErrorMsg('Не вдалося перевірити ключ. Перевірте з’єднання і спробуйте ще раз.');
    }
  }

  return (
    <div className="key-screen">
      <h2 className="key-welcome">Вітаємо!</h2>
      <p className="key-instruction">
        Введіть ключ доступу, надісланий ботом.<br />Отримати його можна через меню<br />"Код авторизації".
      </p>

      <form className="key-form" onSubmit={handleSubmit}>
        <input
          className="key-input"
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="XXXX-XXXX-XXXX-XXXX"
          autoCapitalize="characters"
          autoCorrect="off"
          spellCheck="false"
          disabled={status === 'loading'}
        />
        {status === 'error' && <p className="key-error">{errorMsg}</p>}
        <button className="key-submit" type="submit" disabled={status === 'loading' || !value.trim()}>
          {status === 'loading' ? 'Перевірка...' : 'Продовжити'}
        </button>
      </form>
    </div>
  );
};

export default KeyScreen;
